function colorsTuple(input) {
  if (Array.isArray(input)) {
    return input;
  }
  return Array(10).fill(input);
}

export { colorsTuple };
//# sourceMappingURL=colors-tuple.mjs.map
